(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class SilverHeroCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.dots = [...this.querySelectorAll('[data-hero-dot]')];
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.heroDot), true)));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('[data-hero-slide]');
        if (slide) this.show(Number(slide.dataset.index), true);
      });
      this.startX = null;
      this.addEventListener('pointerdown', (event) => { this.startX = event.clientX; });
      this.addEventListener('pointerup', (event) => {
        if (this.startX === null) return;
        const distance = event.clientX - this.startX;
        this.startX = null;
        if (Math.abs(distance) > 48) this.show(this.index + (distance < 0 ? 1 : -1), true);
      });
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(nextIndex, pause) {
      if (this.slides.length < 2) return;
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, index) => {
        const active = index === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      if (pause) {
        this.stop();
        window.setTimeout(() => this.start(), 5000);
      }
    }

    start() {
      this.stop();
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autoplay !== 'true' || reduced || this.slides.length < 2) return;
      const delay = Math.max(3500, Number(this.dataset.delay) || 5500);
      this.timer = window.setInterval(() => this.show(this.index + 1, false), delay);
    }

    stop() {
      window.clearInterval(this.timer);
    }
  }

  if (!customElements.get('silver-hero-carousel')) customElements.define('silver-hero-carousel', SilverHeroCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-silverco"] && !Shopify.designMode) return;
  try {
    
  class SilverVideoRail extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.rail = this.querySelector('[data-videos-rail]');
      this.videos = [...this.querySelectorAll('video')];
      const section = this.closest('.videos-editorial');
      this.nav = section?.querySelector('.videos-editorial__nav');
      section?.querySelector('[data-videos-prev]')?.addEventListener('click', () => this.move(-1));
      section?.querySelector('[data-videos-next]')?.addEventListener('click', () => this.move(1));
      this.updateNav = () => {
        if (this.nav && this.rail) this.nav.hidden = this.rail.scrollWidth <= this.rail.clientWidth + 2;
      };
      window.requestAnimationFrame(this.updateNav);
      this.resizeObserver = new ResizeObserver(this.updateNav);
      if (this.rail) this.resizeObserver.observe(this.rail);
      this.videos.forEach((video) => video.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => {});
        else video.pause();
      }));
      this.querySelectorAll('[data-video-sonido]').forEach((button) => {
        button.addEventListener('click', () => {
          const video = button.closest('.video-editorial')?.querySelector('video');
          if (!video) return;
          const activate = video.muted;
          if (activate) {
            this.videos.forEach((other) => { other.muted = true; });
            this.querySelectorAll('[data-video-sonido]').forEach((otherButton) => otherButton.setAttribute('aria-pressed', 'false'));
          }
          video.muted = !activate;
          button.setAttribute('aria-pressed', String(activate));
          button.setAttribute('aria-label', activate ? button.dataset.sonidoOn : button.dataset.sonidoOff);
          video.play().catch(() => {});
        });
      });
      if (this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) video.play().catch(() => {});
          else video.pause();
        });
      }, { threshold: .35 });
      this.videos.forEach((video) => this.observer.observe(video));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }

    move(direction) {
      const card = this.rail?.querySelector('.video-editorial');
      if (!card || !this.rail) return;
      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
      this.rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }
  }

  if (!customElements.get('silver-video-rail')) customElements.define('silver-video-rail', SilverVideoRail);

  } catch(e) { console.error(e); }
})();
})();
